// 음성 녹음(blob)을 서버 STT(/api/stt)로 보내 텍스트를 받는다.
// 네이티브에서 Capacitor STT 플러그인 대신 이 경로를 쓴다(getUserMedia로 녹음 → 서버 Gemini 전사).
// 마이크 소비자가 getUserMedia 하나뿐이라, 동시 마이크 충돌(크래시)이 없다.

import { Capacitor } from "@capacitor/core";

const BASE = (typeof import.meta !== "undefined" && import.meta.env?.VITE_STT_ENDPOINT) || "https://bwek.app/api/stt";
// 네이티브(capacitor://localhost)는 절대 URL, 웹은 같은 오리진 상대경로 — judgeClient와 동일 규약.
const ENDPOINT = Capacitor.isNativePlatform() ? BASE : BASE.replace(/^https?:\/\/[^/]+/, "");

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const s = typeof r.result === "string" ? r.result : "";
      resolve(s.includes(",") ? s.slice(s.indexOf(",") + 1) : s);
    };
    r.onerror = () => reject(r.error ?? new Error("base64 변환 실패"));
    r.readAsDataURL(blob);
  });
}

/** 오디오 blob → 텍스트. 실패/타임아웃이면 빈 문자열(받아쓰기 없이 진행, 앱은 안 깨짐). */
export async function serverTranscribe(blob: Blob, lang: string, timeoutMs = 25000): Promise<string> {
  try {
    if (!blob || blob.size === 0) return "";
    const audio = await blobToBase64(blob);
    const mime = blob.type || "audio/mp4";
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeoutMs);
    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ audio, mime, lang }),
        signal: ctrl.signal,
      });
      if (!res.ok) throw new Error(`stt: HTTP ${res.status}`);
      const j = (await res.json()) as { text?: string };
      return typeof j.text === "string" ? j.text.trim() : "";
    } finally {
      clearTimeout(timer);
    }
  } catch {
    return ""; // 전사 실패 — 조용히 빈 문자열
  }
}
